export const initialState = {
  id: null,
  title: null,
  description: null,
  category_id: null,
  poll_url: null,
  status: "inactive",
  options: [{ sortOrder: 1, label: "" }, { sortOrder: 2, label: "" }],
  primary_user_id: null,
  secondary_user_id: null,
  private: false,
  entries: [],
  user_ids: [],
  anonymous: false,
  multiple: false,
  pagination: {
		total: 20,
		per_page: 20,
		current_page: 1,
		last_page: 1,
		from: 1,
		to: 20,
	},
};

export const mockState = {
  id: 1,
  title: "I am a test poll",
  body: "This is a test poll just for testing",
  status: "active",
  date_created: "2021-04-28T11:02:00",
  options: [
    { sortOrder: 1, label: "Option 1" },
    { sortOrder: 2, label: "Option 2" },
    { sortOrder: 3, label: "Option 3" },
  ],
  entries: [
    { userId: 1, answer: 1 },
    { userId: 2, answer: 1 },
    { userId: 3, answer: 1 },
    { userId: 4, answer: 2 },
    { userId: 5, answer: 2 },
    { userId: 6, answer: 3 },
  ],
};

export const state = {
  polls: [],
  entries: [],
  currentPoll: { ...initialState },
  filters: {
    searchQuery: "",
  },
  sortBy: {
    field: "created_time",
    direction: "desc",
  },
  pagination: {
    total: 10,
    per_page: 10,
    current_page: 1,
    last_page: 1,
    from: 1,
    to: 10,
  },
};
